// extracted by mini-css-extract-plugin
module.exports = {"deleteBook":"DeleteBook_deleteBook__3Hquk","pageTitle":"DeleteBook_pageTitle__2FNeG","selectBox":"DeleteBook_selectBox__C2KdE","deleteBtn":"DeleteBook_deleteBtn__UmcPy"};